import React from 'react'
import {Grid,Card} from '@mui/material';
import MyContracts from '../myContracts/MyContracts'
import { useSelector, useDispatch } from 'react-redux';
import { selectTaksatState, displayInvoiceList, displaySingleInvoice, displayMainUtilityView, resetTaksatSlice } from '../../../../../features/taksat/taksatSlice';
import {selectGlobalDataState, setGeneralMessage, setTransactionHasBeenMade} from '../../../../../features/global/globalDataSlice'
import {selectMyContractsState, resetSelectedContractInfo} from '../../../../../features/myContracts/myContractsSlice'
import smallLoadingAnimation from '../../../../../icons/lottieAnimations/smallLoading.json'
import InvoiceList from '../InvoiceList'
import TaksatSingleExpandedInvoice from '../taksat/TaksatSingleExpandedInvoice'
import Lottie from "lottie-react";
import Taksat from './Taksat'
import TaksatInvoiceMultiSelect from './TaksatInvoiceListMultiSelect'
import { useLocation } from "react-router-dom";
import { selectUserInfo } from '../../../../../features/userInfo/userInfoSlice';
import MyContractsTest from '../myContracts/myContractsNew/MyContractsTest';
import { texts } from '../../../../general/texts';

const UtilityTaksat = (props) => {
    const taksatSliceState = useSelector(selectTaksatState) 
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const myContractsSliceState = useSelector(selectMyContractsState)
    const dispatch = useDispatch()
    const location = useLocation()
    const utilityName = location.pathname.slice(location.pathname.lastIndexOf('/') + 1 , location.pathname.length)

    React.useEffect(()=>{
        taksatSliceState.shouldDisplaySingleInvoice && dispatch(displaySingleInvoice())
        taksatSliceState.shouldDisplayInvoiceList && dispatch(displayInvoiceList())
        taksatSliceState.shouldDisplayMainUtilityView && dispatch(displayMainUtilityView())

        if(taksatSliceState.isTransactionSuccessfullyCompleted)
        {
            dispatch(setGeneralMessage({type: 'success', message: texts["message-success-trx"]}))
            dispatch(setTransactionHasBeenMade(true))
            dispatch(resetTaksatSlice())
        }

        return(() => {
            dispatch(resetSelectedContractInfo())
        })
    },[taksatSliceState.isTransactionSuccessfullyCompleted, taksatSliceState.shouldDisplaySingleInvoice, taksatSliceState.shouldDisplayInvoiceList, taksatSliceState.shouldDisplayMainUtilityView])

    return(
        <Grid container spacing={'2%'} pt={'3%'} >
            <Grid container item md={6.5} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} >
                <Card sx={{borderRadius:'20px', boxShadow:'0 0 15px 5px #E5E7EA', width:'60%', '@media (max-width: 1440px )' : {width:'70%'}, '@media (max-width: 1320px )' : {width:'90%'}}}>
                        {taksatSliceState.shouldDisplayInvoiceList === false && taksatSliceState.shouldDisplaySingleInvoice === false && <Taksat selectedContractInfo={myContractsSliceState.selectedContractInfo} utilityName={utilityName} defaultButtonStyle={props.defaultButtonStyle} selectedButtonStyle={props.selectedButtonStyle} taksatSliceState={taksatSliceState} utilityInfo={props.utilityInfo} globalDataSliceState={globalDataSliceState}/>}
                        {taksatSliceState.shouldDisplayInvoiceList === true && <TaksatInvoiceMultiSelect  utilityInfo={props.utilityInfo} utilityName={utilityName} invoices={taksatSliceState.invoiceList} globalDataSliceState={globalDataSliceState} taksatSliceState={taksatSliceState}/>}  
                        {taksatSliceState.shouldDisplaySingleInvoice === true && <TaksatSingleExpandedInvoice utilityName={utilityName} invoice={taksatSliceState.singleInvoice} globalDataSliceState={globalDataSliceState} taksatSliceState={taksatSliceState}/>}  
                        
                        <Grid container justifyContent={'center'}>
                            <Grid item md={3} xs={3}>{taksatSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true}/>}</Grid>
                        </Grid>                                                                     
                    </Card>            
                </Grid>
                <Grid container item md={4.5} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}} > 
                    <MyContractsTest utilityName={utilityName} currentLocation='utility'/>
                </Grid>
        </Grid> 
    )
}

export default UtilityTaksat